// extracted by mini-css-extract-plugin
export var text = "_7i-0";